import React, { Component } from 'react'
import './index.less'

interface OrderButtonProps {
  title: string
  type?: string
  onClick?: () => void
}

export default class OrderButton extends Component<OrderButtonProps> {
  render() {
    let className = this.props.type === 'lookcode' ? 'order-button-orange' : 'order-button-normal'
    return (
      <div className='order-button-content' onClick={this.props.onClick}>
        <span className={className}>
          {this.props.title}
        </span>
      </div>
    )
  }
}